import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
// ------ Services ------ //
import * as leadCaptureService from "../../../services/leadCaptureService"
// ------ Styles ------ //
import styles from './LeadCaptureMonitor.module.css'
// ------ Components ------ //
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LeadsSnapshot from '../../../components/LeadCapture/LeadCaptureMonitor/LeadsSnapshot'

const LeadCaptureMonitor = () => {
    const timeoutRef = useRef(null);
    const longTimeoutRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [loaded, setLoaded] = useState(false);
    const [timerFlag, setTimerFlag] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [leadCaptureSnapshots, setLeadCaptureSnapshots] = useState([]);
    const changeDateFormat = dateStr => {
        if (!dateStr || dateStr === undefined)
        {
            return;
        }
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' };
        const dateFormatted = date.toISOString( options);
        const returnDate = dateFormatted.split('T')[0];
        return returnDate
    }
    const createRequest = () => {
        const fieldsSave = {
            'startDate': startDate,
            'endDate': endDate,
        }
        return fieldsSave
    }
    const fetchLeadCapturSnapshots = async () => {
        try {
            let events = await leadCaptureService.getLeadCaptureMonitor(createRequest())
            if (events) {
                setLeadCaptureSnapshots(events);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setLoaded(true);
    }
    const handleChange = async (e, name) => {
        let date = e.currentTarget.value;
        if (name === 'startDate') {
            setStartDate(date);
        }
        else {
            setEndDate(date);
        }
    }
    useEffect(() => {
        clearTimeout(longTimeoutRef.current);
        longTimeoutRef.current = setTimeout(() => {
            // Perform action here, e.g., 
            setTimerFlag(timerFlag ? false: true);
            fetchLeadCapturSnapshots();
        }, 50000); // Delay of 50000 milliseconds
    }, [loaded, timerFlag])
    useEffect(() => {
        if (startDate && endDate) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                // Perform action here, e.g., 
                fetchLeadCapturSnapshots();
            }, 1500); // Delay of 1500 milliseconds
        }

    }, [startDate, endDate])
    useEffect(() => {
        setStartDate(changeDateFormat(new Date(new Date().setMonth(new Date().getMonth() - 3))));
        setEndDate(changeDateFormat(new Date(new Date().setMonth(new Date().getMonth() + 1)))); // show future events as well
    }, [])
    return (
        
        <div id={styles.leadsSnapshotConfigurePage}>
            <h1>List of lead captures and general statistics.</h1><br />
            <h2>Choose Start and End date range</h2><br />
            <p>
                Page refreshes every 50 seconds, or when date range is modified.
            </p>
            <div className={styles.dropdownContainer}>
            Start Date: 
                <input
                    className={styles.datePicker}
                    type="date"
                    value={changeDateFormat(startDate)}
                    onChange={(e) => handleChange(e, 'startDate')} //pass name as string
                    name="startDate"
                />
            </div>
            <div className={styles.dropdownContainer}>
            End Date:
                <input
                    className={styles.datePicker}
                    type="date"
                    onChange={(e) => handleChange(e, 'endDate')} //pass name as string
                    value={changeDateFormat(endDate)}
                    name="endDate"
                />
            </div>
            <>
                {
                    !loaded ? <LoadingSpinner /> :
                        <>
                            <br />
                            {
                                leadCaptureSnapshots && leadCaptureSnapshots.length > 0 ?
                                    <>
                                        <table className={styles.tableLeadsSnapshots}>
                                            <thead>
                                                <tr className={styles.trLeadsSnapshots}>
                                                    <th className={styles.thLeadsSnapshot}>
                                                        Client
                                                        <HoverButton
                                                            title={'Client name'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thLeadsSnapshot}>
                                                        Lead Capture
                                                        <HoverButton
                                                            title={'Lead Capture name'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thLeadsSnapshot}>
                                                        RefNumber
                                                        <HoverButton
                                                            title={'Lead capture reference number'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thLeadsSnapshot}>
                                                        Start Date
                                                        <HoverButton
                                                            title={'Event start date'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thLeadsSnapshot}>
                                                        Total Scans
                                                        <HoverButton
                                                            title={'Total count of scans for lead capture'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thLeadsSnapshot}>
                                                        Exhibitor Breakdown
                                                        <HoverButton
                                                            title={'Exhibitor/registrant count that have been scanned'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody key={leadCaptureSnapshots.length}>
                                                {leadCaptureSnapshots.map((item, index) => (
                                                    <LeadsSnapshot
                                                        index={index}
                                                        leadsSnapshot={item}
                                                    >
                                                    </LeadsSnapshot>
                                                ))}
                                            </tbody>

                                        </table></>
                                        : <><div className={styles.errorLeadsSnapshots}>No lead captures in specified range!</div>
                                    </>

                            }

                        </>
                }
            </>
            <br /><br />
            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default LeadCaptureMonitor;